import { endPoints } from 'api/';
import { getUsers } from 'actions/users/';
import assignUserWarehouses from 'actions/users/assignUserWarehouses/assignUserWarehouses';
import { CREATE_ADMIN, CREATE_USER } from 'actions/types';

/**
  @description Creates user object
  @param {FormData} payload
  @param {string} companyId Current user's company id.
  @param {boolean} isSigningUp If `true` different action type will be dispatched
  reducer won't track this user since they're not `logged in` yet.
  @param {string} [signupToken] Token from company signup that authorises the first admin.
  @param {string[]} [warehouseIds] Warehouses to assign to the new user once created.
  @returns User object without token and password.
 */
function createUser(
  payload,
  companyId,
  isSigningUp,
  signupToken,
  warehouseIds,
) {
  /**
    @param {Function} dispatch
   */
  return function (dispatch) {
    const query = isSigningUp ? { companyId, signupToken } : '';
    const actionType = isSigningUp ? CREATE_ADMIN : CREATE_USER;
    const action = {
      type: actionType,
      /**
        @param {Function} apiClient
       */
      request: async function (apiClient) {
        const user = await apiClient(endPoints.CREATE_USER, payload, query);
        if (!isSigningUp) {
          dispatch(getUsers({ companyId }));
        }
        if (warehouseIds) {
          const { id: userId } = user.data.response;
          await assignUserWarehouses(apiClient, userId, warehouseIds);
        }
        return user;
      },
    };
    dispatch(action);
  };
}

export default createUser;
